<nz-spin [nzSpinning]="requestRunning" [nzTip]="statusMessage">
  <div class="request-config">
    <h3 class="section-title">{{'jsoncomponent.request.title'|translateTA}}</h3>
    <p class="status-message" *ngIf="statusMessage">{{statusMessage}}</p>

    <div class="tem-field">
      <span class="tem-field-label">{{'jsoncomponent.request.serviceName'|translateTA}}</span>
      <input nz-input [(ngModel)]="data.requestConfig.serviceName"
        [placeholder]="'jsoncomponent.request.serviceNamePlaceholder'|translateTA">
    </div>

    <div class="tem-field">
      <span class="tem-field-label">{{'jsoncomponent.request.urlType'|translateTA}}</span>
      <input nz-input [(ngModel)]="data.requestConfig.urlType"
        [placeholder]="'jsoncomponent.request.urlTypePlaceholder'|translateTA">
    </div>

    <div class="tem-field">
      <span class="tem-field-label">{{'jsoncomponent.request.method'|translateTA}}</span>
      <nz-select [(ngModel)]="data.requestConfig.method">
        <nz-option nzValue="GET" nzLabel="GET"></nz-option>
        <nz-option nzValue="POST" nzLabel="POST"></nz-option>
        <nz-option nzValue="PUT" nzLabel="PUT"></nz-option>
        <nz-option nzValue="DELETE" nzLabel="DELETE"></nz-option>
      </nz-select>
    </div>

    <div class="tem-field">
      <span class="tem-field-label">{{'jsoncomponent.request.params'|translateTA}}</span>
      <input nz-input [(ngModel)]="data.requestConfig.params"
        placeholder="?getFullShopeeParams({{'{'}}@CODECOMPANY},...)">
    </div>

    <div class="tem-field">
      <div class="tem-field-label-row">
        <span class="tem-field-label">{{'jsoncomponent.request.body'|translateTA}}</span>
        <span class="tem-field-suffix">
          <button nz-button nzType="link" nzSize="small" type="button" nz-tooltip
            [nzTooltipTitle]="'jsoncomponent.request.testFormula'|translateTA" (click)="testFormula('B')">
            <nz-icon nzType="play-circle" />
          </button>
        </span>
      </div>
      <textarea nz-input rows="5" [(ngModel)]="data.formula"
        [placeholder]="'jsoncomponent.request.bodyPlaceholder'|translateTA"></textarea>
    </div>

    <div class="tem-field">
      <div class="tem-field-label-row">
        <span class="tem-field-label">{{'jsoncomponent.request.header'|translateTA}}</span>
        <span class="tem-field-suffix">
          <button nz-button nzType="link" nzSize="small" type="button" nz-tooltip
            [nzTooltipTitle]="'jsoncomponent.request.testFormula'|translateTA" (click)="testFormula('H')">
            <nz-icon nzType="play-circle" />
          </button>
        </span>
      </div>
      <textarea nz-input rows="3" [(ngModel)]="data.requestConfig.headerFormula"
        [placeholder]="'jsoncomponent.request.headerPlaceholder'|translateTA"></textarea>
    </div>

    <div class="tem-field">
      <span class="tem-field-label">{{'jsoncomponent.request.codeMktp'|translateTA}}</span>
      <input nz-input [(ngModel)]="data.requestConfig.codeMktp"
        [placeholder]="'jsoncomponent.request.codeMktpPlaceholder'|translateTA">
    </div>

    <div class="request-actions">
      <button nz-button nzType="primary" type="button" (click)="save()">{{'save'|translateTA}}</button>
      <button nz-button type="button" [nzLoading]="requestRunning" (click)="testRequest()">
        <nz-icon nzType="play-circle" />{{'jsoncomponent.request.test'|translateTA}}
      </button>
    </div>

    <div class="json-preview">
      <div class="json-preview-header">
        <h3 class="section-title">{{'jsoncomponent.generatedJson'|translateTA}}</h3>
        <button nz-button nzType="link" type="button" nz-tooltip
          [nzTooltipTitle]="'jsoncomponent.copyJson'|translateTA" (click)="copyJson()">
          <nz-icon nzType="copy" />
        </button>
      </div>
      <nz-empty *ngIf="!json" nzNotFoundImage="simple"
        [nzNotFoundContent]="'jsoncomponent.request.emptyJson'|translateTA"></nz-empty>
      <pre *ngIf="json">{{ getFormattedJSON() }}</pre>
    </div>

  </div>
</nz-spin>
